var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-xs-center"},[_vm._v("Business Client Detail")]),_c('v-card',{staticClass:"mt-3"},[_c('businesslist_client')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }